import { HttpHeaders } from '@angular/common/http';
import { ApolloClientOptions, DefaultOptions, InMemoryCache } from '@apollo/client';
import { HttpBatchLink } from 'apollo-angular/http';
import { environment } from '../environments/environment';

const defaultOptions: DefaultOptions = {
    watchQuery: {
        fetchPolicy: 'no-cache'
    },
    query: {
        fetchPolicy: 'no-cache',
        errorPolicy: 'all'
    }
};

// Function to create an Apollo Client for mt-reporter
export function createApolloClientMtReporter(httpLink: HttpBatchLink): ApolloClientOptions<any> {
    return {
        link: httpLink.create({
            batchMax: 10,
            batchInterval: 10,
            uri: environment.NX_API_URL,
            headers: new HttpHeaders({
                'x-api-key': environment.NX_API_KEY,
                'x-batch': 'true'
            })
        }),
        cache: new InMemoryCache(),
        defaultOptions
    };
}

// Function to create an Apollo Client for data-solutions
export function createApolloClientMediascope(httpLink: HttpBatchLink): ApolloClientOptions<any> {
    return {
        link: httpLink.create({
            batchMax: 10,
            batchInterval: 10,
            uri: environment.NX_API_URL_DS,
            headers: new HttpHeaders({
                'x-api-key': environment.NX_API_KEY_DS,
                'x-batch': 'true'
            })
        }),
        cache: new InMemoryCache(),
        defaultOptions
    };
}

// Function to create an Apollo Client for unified-common / core
export function createApolloClientCore(httpLink: HttpBatchLink): ApolloClientOptions<any> {
    return {
        link: httpLink.create({
            batchMax: 10,
            batchInterval: 10,
            uri: environment.NX_API_URL_CORE,
            headers: new HttpHeaders({
                'x-api-key': environment.NX_API_KEY_CORE,
                'x-batch': 'true'
            })
        }),
        cache: new InMemoryCache(),
        defaultOptions
    };
}
